export const COMPANY = 'Engiweb Ltd'
export const COPYRIGHT = `© ${COMPANY} 2016-${new Date().getFullYear()} | All Rights Reserved`
export const ADDRESS = 'Kemp House, 152-160 City Rd, Old Street, London EC1V 2NX, United Kingdom'
export const EMAIL = 'info@engiweb.com'
export const MAILTO = `mailto:${EMAIL}`
export const MAP = 'https://www.google.com/maps/place/Engiweb/@51.527265,-0.0889208,15z/data=!4m5!3m4!1s0x0:0x4cccf548e125e4dc!8m2!3d51.527265!4d-0.0889208'
export const GA_CODE = 'UA-88733352-1'
